export const AUTH_SIGNIN = 'AUTH:AUTH_SIGNIN';
export const AUTH_SIGNOUT = 'AUTH:AUTH_SIGNOUT';
export const TOGGLE_MENU = 'AUTH:TOGGLE_MENU';



// WEBPACK FOOTER //
// ./src/auth/actions/types.js